<template>
  <v-layout wrap>
    <v-flex>
      <v-layout wrap style="background-color: #08130b">
        <v-flex md6 lg7>
          <v-layout wrap pa-lg-12 pa-md-12 pa-2>
            <v-flex
              pt-lg-3
              pb-2
              xs12
              offset-lg-1
              justify-center
              style="font: 40px blackbold; color: #bababa"
            >
              Hivekeep
            </v-flex>
            <v-flex
              xs12
              lg9
              offset-lg-1
              justify-center
              pr-12
              style="font-family: sofiapro; color: #adadad"
            >
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry’s standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged.
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md3 lg2 pt-lg-12 align-self-end pl-3 pl-md-0>
          <v-layout
            pt-lg-8
            wrap
            justify-center
            style="
              text-transform: uppercase;
              font: 12px poplight;
              color: #adadad;
            "
          >
            <v-flex xs12 pb-lg-5 pb-3>
              <router-link
                style="text-decoration: none; color: #adadad"
                to="/aboutus"
              >
                About Us
              </router-link>
            </v-flex>
            <v-flex xs12 pb-lg-5 pb-3>
              <router-link
                style="text-decoration: none; color: #adadad"
                to="/products"
              >
                Shop
              </router-link>
            </v-flex>
            <v-flex xs12 pb-lg-5 pb-3>
              <router-link
                style="text-decoration: none; color: #adadad"
                to="/map"
              >
                Map
              </router-link>
            </v-flex>
            <v-flex xs12 pb-lg-5 pb-3>
              <router-link
                style="text-decoration: none; color: #adadad"
                to="/blog"
              >
                Blog
              </router-link>
            </v-flex>
            <v-flex xs12 pb-lg-5 pb-3> Projects </v-flex>
            <v-flex xs12 pb-lg-5 pb-3>
              <router-link
                style="text-decoration: none; color: #adadad"
                to="/beekeepers"
              >
                BeeKeepers
              </router-link>
            </v-flex>
            <v-flex xs12>
              <router-link
                style="text-decoration: none; color: #adadad"
                to="/contactUs"
              >
                Contact
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex sm6 md3 lg3 align-self-end pr-lg-3 pl-3 pl-md-0>
          <v-layout wrap style="font-family: poplight; color: #adadad">
            <v-flex xs12 align-self-center pb-lg-12 pb-5>
              <v-layout wrap py-2 py-md-0>
                <v-flex xs2 md2>
                  <v-img
                    width="25px"
                    src="../../assets/images/twit.svg"
                  ></v-img>
                </v-flex>
                <v-flex xs2 md2>
                  <v-img
                    width="25px"
                    contain
                    height="25px"
                    src="../../assets/images/facebook.svg"
                  ></v-img>
                </v-flex>
                <v-flex md2>
                  <v-img
                    width="25px"
                    src="../../assets/images/linkedin.svg"
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 align-self-center pb-5>
              <span style="padding-right: 8%; color: #adadad">
                <v-icon style="color: #adadad" size="25px"
                  >mdi-email</v-icon
                ></span
              >
              <span style="font-family: sofiapro">hivekeep@gmail.com</span>
            </v-flex>
            <v-flex xs12 align-self-center>
              <span style="padding-right: 8%; color: #adadad">
                <v-icon style="color: #adadad" size="25px"
                  >mdi-phone</v-icon
                ></span
              >
              <span>+918494000 000</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        style="background-color: #08130b; color: #adadad; font-family: poplight"
        wrap
        text-center
        py-lg-12
      >
        <v-flex py-3> LEOPARD TECH LABS PVT.LTD </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
export default {};
</script>